/**
 * Klaam — Global JS
 * Scroll reveal, sticky nav, smooth interactions
 */

(function () {
  'use strict';

  // ── Scroll Reveal ─────────────────────────────────────────
  function initReveal() {
    var els = document.querySelectorAll('[data-klaam-reveal]');
    if (!els.length) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.dataset.klaamDelay || 0;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, parseInt(delay, 10));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  // ── Smooth Anchor Scrolling ───────────────────────────────
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ── Hero Slideshow ────────────────────────────────────────
  function initHeroSlideshow() {
    var slides = document.querySelectorAll('.klaam-hero__slide');
    var dots   = document.querySelectorAll('.klaam-hero__dot');
    if (!slides.length) return;
    var current = 0;

    function goTo(n) {
      slides[current].classList.remove('klaam-hero__slide--active');
      if (dots[current]) dots[current].classList.remove('klaam-hero__dot--active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('klaam-hero__slide--active');
      if (dots[current]) dots[current].classList.add('klaam-hero__dot--active');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    setInterval(function () { goTo(current + 1); }, 4500);
  }

  // ── Hero Parallax (subtle) ────────────────────────────────
  function initHeroParallax() {
    var heroImage = document.querySelector('.klaam-hero__image');
    if (!heroImage) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrolled = window.scrollY;
          var limit = 800;
          if (scrolled < limit) {
            heroImage.style.transform = 'translateY(' + (scrolled * 0.2) + 'px) scale(1)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── FAQ Accordion ─────────────────────────────────────────
  function initFAQ() {
    document.querySelectorAll('.klaam-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.klaam-faq__item');
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('.klaam-faq__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initSmoothAnchors();
    initHeroSlideshow();
    initHeroParallax();
    initFAQ();
  });

})();